import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GroupModel } from 'src/app/core/models/group.model';
import { PermissionModel } from 'src/app/core/models/permission.model';
import { AccountsService } from 'src/app/core/services/accounts.service';
import { FormRendererComponent } from 'src/app/shared/renderers/form-renderer/form-renderer.component';
import { FormInput, inputType } from 'src/app/shared/renderers/models/form-input';
import { FormTemplate } from 'src/app/shared/renderers/models/form-template';
import { OptionModel } from 'src/app/shared/renderers/models/option';

@Component({
  selector: 'app-user-group-edit',
  templateUrl: './user-group-edit.component.html',
  styleUrls: ['./user-group-edit.component.scss']
})
export class UserGroupEditComponent implements OnInit {
  formTemplate: FormTemplate = {
    renderOnInit: false,
    fullLoading: true,
    groupName: "userGroupForm",
    submitButton: { label: "Salvar" },
    cancelButton: { label: "Cancelar" },
    cancelLink: "/dashboard/registers/userGroups",
    submitted: false,
    separators: [
      {
        groupName: "groupData",
        inputs: [
          { name: "name", label: "Nome do grupo", type: inputType.BASIC, widthInCols: { sm: 8 }, validators: [Validators.required] }
        ],
      },
      {
        groupName: "groupPermissions",
        title: "Permissões do grupo",
        inputs: [
        ]
      },
    ]
  };

  id!: number;

  @ViewChild(FormRendererComponent) renderedForm!: FormRendererComponent;

  permissions!: PermissionModel[];

  constructor(private accountsService: AccountsService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.fetchUserGroupData();
    })
  }

  submitHandler() {
    const userGroupData = this.getFormData();
    this.userGroupEdit(userGroupData);
  }

  async userGroupEdit(userGroupData: GroupModel) {
    try {
      await this.accountsService.groupEdit(userGroupData).toPromise();
      this.formTemplate.submitted = true;
      this.router.navigate(['/dashboard/registers/userGroups'])
    }
    catch (error) {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.formTemplate.loading = false;
    }
  }

  async fetchUserGroupData() {
    try {
      this.permissions = await (await this.accountsService.permissionsList().toPromise());
      this.setPermissions();
      const userGroupData = await this.accountsService.groupGet(this.id).toPromise();
      this.setFormData(userGroupData);
      this.formTemplate.fullLoading = false;
    }
    catch (error) {
      const response = error as HttpErrorResponse;
      this.mapErrorResponse(response);
      this.router.navigate(["/dashboard/registers/userGroups"]);
    }
  }

  mapErrorResponse(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["detail"]) {
      alert(errorResponse.error["detail"]);
    }
    else {
      this.setFormErrors(errorResponse);
    }
  }

  getFormData(): GroupModel {
    var selectedPermissions: number[] = [];

    Object.values(this.renderedForm.formGroup.get("groupPermissions")?.value).forEach((permissionGroup) => {
      const selectedPermissionsCodenames = permissionGroup as string[];

      selectedPermissionsCodenames.forEach((selectedPermissionCodename) => {
        this.permissions.forEach((permission) => {
          if (permission.codename == selectedPermissionCodename)
            selectedPermissions.push(permission.id!)
        })
      });
    });

    return {
      id: this.id,
      name: this.renderedForm.formGroup.value['groupData']['name'],
      permissions: selectedPermissions
    } as GroupModel;
  }

  setPermissions() {
    Object.values(this.groupBy(this.permissions, "content_type")).forEach((values: any) => {
      const options = (values as PermissionModel[]).map(({ codename, name }) => ({ name: codename, label: name }) as OptionModel);
      const input = {
        name: options[0].name,
        type: inputType.CHECKBOX,
        label: values[0]['model'],
        dropdownOptions: options,
        widthInCols: { sm: 4 }
      } as FormInput
      this.formTemplate.separators![1].inputs?.push(input);
    });
  }

  setFormData(userGroupData: GroupModel) {
    const selectedPermissionsCodenames: string[] = [];
    this.permissions.forEach((permission) => {
      userGroupData.permissions.forEach((selectedPermissionId) => {
        if (permission.id == selectedPermissionId)
          selectedPermissionsCodenames.push(permission.codename!)
      })
    })

    this.formTemplate.separators![1].inputs?.forEach((formInput: FormInput) => {
      formInput.dropdownOptions?.forEach((checkBox: OptionModel) => {
        selectedPermissionsCodenames.forEach((selectedPermission: string) => {
          if (checkBox.name == selectedPermission) {
            checkBox.checked = true;
          }
        })
      })
    })

    this.renderedForm.initializeForm();
    this.renderedForm.formGroup.get("groupData")?.get("name")?.setValue(userGroupData.name);
  }

  groupBy(arr: any[], property: string) {
    return arr.reduce((acc, cur) => {
      acc[cur[property]] = [...acc[cur[property]] || [], cur];
      return acc;
    }, {});
  }

  setFormErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error["name"]) this.renderedForm.formGroup.get("groupData")?.get("name")?.setErrors({ response: errorResponse.error['name'] });
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.renderedForm.formExitHandler();
  };
}
